<template>
    <v-bottom-navigation
        background-color="backGroundPrimary"
        color="primary" height="64" app shift fixed
        :class="['nav-container', {'disable-footer': dialogActive}]"
    >
        <v-btn
            v-for="item in items" :key="item.title"
            :id="item.ref"
            :ref="item.ref"
            :to="item.link || null"
        >
            <div v-if="item.count && item.count > 0" class="badge">
                {{ item.count }}
            </div>
            <span>{{ item.title }}</span>
            <v-icon>{{ item.icon }}</v-icon>
        </v-btn>
    </v-bottom-navigation>

</template>

<script>

import {links} from "@/mixins/baseGlobalMixin";

export default {
    components: {},
    mixins: [links],
}
</script>

<style scoped>

.badge {
    opacity: 1 !important;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    color: #fff;
    top: 6px !important;
    right: 0 !important;
    width: 17px;
    height: 17px;
    border-radius: 17px;
    background-color: var(--v-secondary-base);
}

.nav-container {
    box-shadow: none;
    padding-bottom: 74px;
}

.theme--light.v-bottom-navigation .v-btn:not(.v-btn--active) {
    color: var(--v-primary-base) !important;
}

::v-deep .v-btn.v-btn--router.theme--light.v-size--default {
    min-width: 15%;
}

::v-deep .v-btn.v-btn--router.theme--light.v-size--default:not(.v-btn--active) {
    opacity: .5;
}

::v-deep .v-btn.v-btn--router.theme--light.v-size--default:not(.v-btn--active) > .v-btn__content > .badge {
    top: 12px !important;
}

::v-deep .v-btn:not(.v-btn--text):not(.v-btn--outlined):hover:before {
    opacity: 0;
}

.disable-footer {
    pointer-events: none;
}

</style>